import PedidoRevisao from './PedidoRevisao';

export default PedidoRevisao;